/* eslint-disable import/prefer-default-export */
import { invert } from "lodash";
import { makeFormatDecimal } from "utils/formatting";
import { WeightUnit } from "__generated__/gql/graphql";

export const WEIGHT_UNIT_LABELS: Record<WeightUnit, string> = {
  [WeightUnit.FL_OUNCE]: "Fluid Ounce",
  [WeightUnit.GRAM]: "Gram",
  [WeightUnit.MILLILITER]: "Milliliter",
  [WeightUnit.OUNCE]: "Ounce",
};

export const WEIGHT_UNIT_BY_LABEL = invert(WEIGHT_UNIT_LABELS) as Partial<
  Record<string, WeightUnit>
>;

export const INTL_UNIT_BY_WEIGHT_UNIT: Record<WeightUnit, string> = {
  [WeightUnit.FL_OUNCE]: "fluid-ounce",
  [WeightUnit.GRAM]: "gram",
  [WeightUnit.MILLILITER]: "milliliter",
  [WeightUnit.OUNCE]: "ounce",
};

export function makeFormatWeightUnit(
  weightUnit: WeightUnit,
  options?: Intl.NumberFormatOptions,
) {
  return makeFormatDecimal({
    style: "unit",
    unit: INTL_UNIT_BY_WEIGHT_UNIT[weightUnit],
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
    ...options,
  });
}

export function getWeightUnitExcelFormat(weightUnit: WeightUnit) {
  const formatted = makeFormatWeightUnit(weightUnit)(10);
  if (!formatted) return;
  return formatted.replace(/(^.*?)\d+(?:\.\d+)?(.*$)/, (s, p1, p2) => {
    const beforeNum = p1 ? `"${p1}"` : "";
    const afterNum = p2 ? `"${p2}"` : "";
    return `${beforeNum}General${afterNum}`;
  });
}
